import { render, staticRenderFns } from "./IdentityOperations.vue?vue&type=template&id=723954e8&scoped=true"
import script from "./IdentityOperations.vue?vue&type=script&lang=js"
export * from "./IdentityOperations.vue?vue&type=script&lang=js"
import style0 from "./IdentityOperations.vue?vue&type=style&index=0&id=723954e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723954e8",
  null
  
)

export default component.exports